export default __webpack_public_path__ + "static/media/CryptoDisable.f057710d.svg";